import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";

import App from "./App";
import { jobsiteJeff } from "./fun";
import reportWebVitals from "./reportWebVitals";
import { errorTracker, mixpanel } from "./utils";

// Initialize error tracking before anything else to
// match as many issues as possible
errorTracker.init();

// Initialize Mixpanel for Jobsite Jacob
mixpanel.init();

// Jobsite Jeff ASCII 🎨 ✨
jobsiteJeff.logConsoleAsciiArt();

// Initialize & render our app
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
